// 服务
export const SERVICES = [
  {
    name: '金榜带学',
    desc: '全国金榜前辈，1v1带学辅导，学习问题急速响应',
    icon: 'iconbeizhu',
  },
  {
    name: '私教预约',
    desc: '私教老师随时约，来一场属于自己的专属课堂',
    icon: 'iconyiwen',
  },
  {
    name: '核心百题',
    desc: '试题剖析解读，举一反三极速掌握考点，落地应试考试',
    icon: 'iconzhibohudong',
  },
  {
    name: '小班教学',
    desc: '20人小班管理，三人成组告别孤军奋战',
    icon: 'iconshuben',
  },
  {
    name: '学习计划',
    desc: '定制学习计划，任务式学习，具体落实到每周，稳步前进',
    icon: 'icongaishuai',
  },
  {
    name: '双师教学',
    desc: '打造高端双师教学模式，保障高品质教学输出',
    icon: 'iconjiaoyu',
  },
  {
    name: '错题打印',
    desc: '汇总全年数据，并有老师点评批注，给出最后15天备考建议',
    icon: 'iconxiazai',
  },
  {
    name: '移动课堂',
    desc: '手机电脑iPad，学习随时随地',
    icon: 'iconshouji',
  },
];

// 评论
export const COMMENTS = [
  {
    content:
      '带学老师真的很负责，解决了我的学习问题，不懂的问题，基本上随问随答，真的是太好了，班级的安排也很好',
    time: '2020-10-15',
  },
  {
    content: '喜欢卓考网校的课',
    time: '2020-09-21',
  },
  {
    content:
      '听了卓考网校的课，现在感觉棒棒哒。老师普通话标准，讲课的逻辑很清晰，举得例子也接地气，一听就能理解，课下配合着卓考督学打卡系统，知识学的很牢固。这个学习吧关键还是靠自己自觉，希望自己能坚持下去！第一次报名中级，希望可以有个好的成绩。',
    time: '2020-08-15',
  },
  {
    content: '不错，感觉还是挺好的，性价比可以',
    time: '2020-06-25',
  },
  {
    content:
      '课程开通之后看了几天才来评价的，很不错的，老师讲的超详细，通俗易懂，能小程序直接学习，超级棒，学霸笔记印刷的很清晰，考点重点总结的很全面，需要掌握熟悉了解的都标注上了。好好学习，一次考过，加油！！！',
    time: '2020-04-01',
  },
  {
    content: '老师很好，讲的很细致，值得购买',
    time: '2020-03-20',
  },
  {
    content:
      '第一次买网课，商家的分期免息活动很好，很适合我这种想学习又月月光的。老师讲的很详细课上趣幽默，希望今年可以一次通过考试，升职加薪·····很喜欢这门课',
    time: '2020-03-05',
  },
];
